import { useState } from "react";
import { toast } from "sonner";
import { X, Copy, Tag } from "@phosphor-icons/react";
import { useConfig } from "@/hooks/useConfig";

const KEY = "bs_banner_dismissed";

export function LaunchBanner() {
  const { config } = useConfig();
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");

  if (hidden || !config?.banner_enabled || !config?.banner_text) return null;

  const copy = async () => {
    await navigator.clipboard?.writeText(config.banner_coupon);
    toast.success(`Code ${config.banner_coupon} copied — use it at checkout`);
  };

  return (
    <div className="relative bg-[#1C1917] text-[#E8DFD2]" data-testid="launch-banner">
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-center gap-x-4 gap-y-2 px-10 py-2.5 text-center sm:px-8">
        <p className="flex items-center gap-2 text-xs sm:text-sm">
          <Tag size={15} weight="duotone" className="text-[#C98A7E]" />
          {config.banner_text}
        </p>
        {config.banner_coupon && (
          <button
            type="button"
            onClick={copy}
            className="inline-flex items-center gap-1.5 rounded-sm border border-white/25 px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.14em] transition-colors duration-200 hover:border-[#C98A7E] hover:text-[#C98A7E]"
            data-testid="banner-copy-code-button"
          >
            {config.banner_coupon} <Copy size={13} weight="bold" />
          </button>
        )}
      </div>
      <button
        type="button"
        onClick={() => { localStorage.setItem(KEY, "1"); setHidden(true); }}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 text-[#E8DFD2]/60 transition-colors hover:text-white"
        aria-label="Dismiss offer"
        data-testid="banner-dismiss-button"
      >
        <X size={15} weight="bold" />
      </button>
    </div>
  );
}
